/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from "react";
import PropTypes from "prop-types";
import "./style.less";
import axios from 'axios/dist/axios.min.js'
import utils from "../../utils/utils";
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { uploadExposure } from '../../utils/exposureRequest';
// import ExposureView from '../../baseComponents/ExposureView'

const topIndexImgs = [
  'https://static.shihuocdn.cn/admin/files/20210805/bd00c7aa7856085cd5ac906372598e45.png',
  'https://static.shihuocdn.cn/admin/files/20210805/1837a593c1bf571b0b6553390f22fb1c.png',
  'https://static.shihuocdn.cn/admin/files/20210805/748329a8aedc56e45f6d723832188a5b.png',
]

const cateMap = {
  '鞋类': {
    bg: 'https://static.shihuocdn.cn/admin/files/20211216/351bf146eb012937e400543ed9bd3efc.png',
    color: '#2b52a2',
    cateIds: [ '9',   '12',  '14', '16',  '43',  '51', '63',  '70',  '491', '538', '540' ]
  },
  '服装配饰': {
    bg: 'https://static.shihuocdn.cn/admin/files/20210806/cb3b60c26eeeb42d3cddf81159f7f75a.png',
    color: '#a04cd9',
    cateIds: [ '11', '20', '21', '45', '33',  '84', '155', '348', '454', '455', '456', '457' ]
  },
  '综合': {
    bg: 'https://static.shihuocdn.cn/admin/files/20210806/db3d382c1eb744ad70bec05bec8fafe9.png',
    color: '#6634C3',
    cateIds: [ '62',  '177', '532', '541', '120', '122', '518', '530', '459', '461', '772', '499', '572', '671', '673', '674', '676', '688', '762' ]
  },
  '数码': {
    bg: 'https://static.shihuocdn.cn/admin/files/20210806/e3170460c6cfae4a8558d1b00ccbcf63.png',
    color: '#2570b5',
    cateIds: [ '187', '197', '198', '199', '202', '203', '215', '216', '219', '317', '229', '230', '484', '485', '488', '507', '470', '471', '472', '473', '474', '476', '478', '664', '486', '492', '494', '500', '501', '503', '504', '505', '656', '665', '708', '317' ]
  },
  '美妆': {
    bg: 'https://static.shihuocdn.cn/admin/files/20210806/7a7dfba90c82adfa87602b0b43cdde7d.png',
    color: '#cb406b',
    cateIds: [ '262', '264', '266', '268', '269', '294', '303', '335', '366', '367', '406', '340', '342', '346', '347', '360', '361', '362', '365', '368' ]
  },
  '手表': {
    bg: 'https://static.shihuocdn.cn/admin/files/20211216/f983d97d2889db2912f37a10f53b0623.png',
    color: '#078da5',
    cateIds: [ '61' ]
  },
  '箱包': {
    bg: 'https://static.shihuocdn.cn/admin/files/20211216/f94a3a6a7c41a875062285649e07e875.png',
    color: '#d75b51',
    cateIds: [ '57', '150', '352', '412', '148' ]
  },
}

const uselessRankIds = [
  6372,
  5998,
  5971,
  5973,
  5975,
  6012,
  6015,
  6380,
  6256,
  6260,
  6264,
  6272,
  6273,
  6274,
  6280,
  6283,
  6285,
  6288,
  6290,
  6297,
  6302,
  6305,
  6311,
  6316,
  6318,
  6321,
  6329,
  6339,
  6341,
  6343,
  6345,
  5958,
  5961,
  6095,
]

class PipelineRankCollection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: this.props.config.list.slice(0, 3),
      curNavIndex: 0,
      navFixed: false
    }
    this.inView = false
  }

  componentDidMount() {
    this.getRankInfo(0, 0)
    this.getRankInfo(1, 0)
    this.getRankInfo(2, 0)

    if (typeof window !== "undefined") {
      window.addEventListener('scroll',(e)=>{
        this.handleBodyScroll();
      });
    }
  }
  
  componentWillUnmount() {
    window.removeEventListener('scroll', () => {})
  }

  getRankInfo = (navIndex, rangeIndex) => {
    const { list } = this.state
    const { priceRanges } = list[navIndex] || {}
    if (!priceRanges) return
    const range = priceRanges[rangeIndex] || {}
    const { ranks } = range
    const useabelList = []
    const uselessList = []
    ranks.forEach(item => {
      if (uselessRankIds.includes(+item.rank_id)) {
        uselessList.push(item)
      } else {
        useabelList.push(item)
      }
    })
    const arr = []
    for (let i = 0; i < 21; i++) {
      const random = Math.random()
      if (random < 0.3 && uselessList.length > 0) {
        const randomIndex = Math.floor(Math.random() * uselessList.length)
        const item = uselessList.splice(randomIndex, 1)[0]
        arr.push({
          cate_id: +item.cate_id,
          rank_id: +item.rank_id,
          rank_subTitle: item.subTitle,
          rank_background: item.backgroundImage
        })
      } else if (useabelList.length > 0) {
        const randomIndex = Math.floor(Math.random() * useabelList.length)
        const item = useabelList.splice(randomIndex, 1)[0]
        arr.push({
          cate_id: +item.cate_id,
          rank_id: +item.rank_id,
          rank_subTitle: item.subTitle,
          rank_background: item.backgroundImage
        })
      }
    }

    axios({
      baseURL: process.env.NODE_ENV == 'development' ? '' : 'https://sh-gateway.shihuo.cn',
      url: '/v4/services/sh-venueapi/common/rankInfoByIds?access_token=znSnA7pxO35wtPBaur',
      method: 'post',
      withCredentials: true,
      data: {
        ranks: arr
      },
    }).then(res => {
      res = res.data
      if (res.status == 0) {
        range.rankList = res.data.list || []
        range.rankList.forEach((rank, rankIndex) => {
          rank.rankIndex = rankIndex
          const rank_subTitle = (arr.find(item => item.rank_id == rank.id) || {}).rank_subTitle;
          const rank_background = (arr.find(item => item.rank_id == rank.id) || {}).rank_background;
          const cate_id = (arr.find(item => item.rank_id == rank.id) || {}).cate_id
          rank.rank_subTitle = rank_subTitle;
          rank.rank_background = rank_background;
          if (cate_id) {
            for (let key in cateMap) {
              const item = cateMap[key]
              if (item.cateIds.includes(cate_id + '')) {
                rank.bg = item.bg
                rank.color = item.color
                break
              }
            }
            if (!rank.bg) {
              rank.bg = 'https://static.shihuocdn.cn/admin/files/20211216/351bf146eb012937e400543ed9bd3efc.png'
              rank.color = '#6634C3'
            }
          }
        })
        range.curGroup = range.rankList.slice(0, 3)
        range.expandLength = 3;
        this.setState({ list }, () => {
          setTimeout(() => {
            range.rankList.forEach((rank, rankIndex) => {
              this.handleXScroll(navIndex, rankIndex, true)
            })            
          }, 1000);
        })
      }
    })
  }

  handleBodyScroll = () => {
    const tabBar = window.document.querySelector('.present-nav-container')
    const tabBarHeight = tabBar.clientHeight
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    const navOffsetTop = tabBar.offsetTop - this.props.navigationBarHeight;
    const navFixed = scrollHeight - navOffsetTop >= 0 && scrollHeight - navOffsetTop <= window.document.querySelector('.pipeline-present').clientHeight - tabBarHeight
    if (navFixed != this.state.navFixed) {
      this.setState({
        navFixed
      });
    }

    const list = window.document.querySelectorAll('.present-item') || [];
    const stopIndex = list.length - 1
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i]
      if (item && scrollHeight >= item.offsetTop - tabBarHeight - this.props.navigationBarHeight) {
        if (i == list.length - 1 || scrollHeight < list[i + 1].offsetTop - tabBarHeight - this.props.navigationBarHeight) {
          const curNavIndex = i > stopIndex ? stopIndex : i
          if (curNavIndex != this.state.curNavIndex) {
            this.setState({
              curNavIndex
            })
          }
          break
        }
      }
    }
  }

  handleNavItemClick = (navIndex) => {
    document.documentElement.scrollTop = window.document.querySelectorAll('.present-item')[navIndex].offsetTop - this.props.navigationBarHeight - window.document.querySelector('.present-nav-container').clientHeight + (utils.isAndroid() ? 1 : 1)
    document.body.scrollTop = window.document.querySelectorAll('.present-item')[navIndex].offsetTop - this.props.navigationBarHeight - window.document.querySelector('.present-nav-container').clientHeight + (utils.isAndroid() ? 1 : 1)
    this.setState({
      curNavIndex: navIndex,
    })
  }

  changeRankGroup = (curRange, navIndex) => {
    
    curRange.expandLength = curRange.expandLength + 3 >= curRange.rankList.length ? curRange.rankList.length : curRange.expandLength + 3;
    curRange.curGroup = curRange.rankList.slice(0, curRange.expandLength)

    this.setState({})

    for (let i = 0; i < 3; i++) {
      const scrollEl = document.querySelector(`.rank-goods-list-${navIndex}-${i}`)
      if (scrollEl) {
        scrollEl.scrollTo(0, 0)
      }
    }
  }

  getGiftType = (navIndex) => {
    switch(navIndex) {
      case 1:
        return 1
      case 0:
        return 2
      case 2:
        return 3
      default:
        return ''
    }
  }

  goRankPage = (rank, type, navIndex) => {
    const options = {
      link: rank.href,
    };
    utils.jumpToUrl(this.props.routeParams,rank.href,rank.href,options, -1,this.props,false);
  }
  

  handleGoodsClick = (goodsItem, goodsIndex, rank, navIndex) => {
    const options = {
      link: goodsItem.detailHref,
      sort: goodsIndex,
    };
    utils.jumpToUrl(this.props.routeParams,goodsItem.detailHref,goodsItem.detailHref,options, -1,this.props,false);
  }

  handlePriceRangeClick = (item, rangeIndex, navIndex) => {
    item.curRangeIndex = rangeIndex
    this.setState({})
    const { list } = this.state
    const range = list[navIndex].priceRanges[rangeIndex]
    if (!range.rankList || range.rankList.length == 0) {
      this.getRankInfo(navIndex, rangeIndex)
    }

    if (navIndex != this.state.curNavIndex) {
      document.documentElement.scrollTop = window.document.querySelectorAll('.present-item')[navIndex].offsetTop - this.props.navigationBarHeight - window.document.querySelector('.present-nav-container').clientHeight + (utils.isAndroid() ? 0 : 42)
      document.body.scrollTop = window.document.querySelectorAll('.present-item')[navIndex].offsetTop - this.props.navigationBarHeight - window.document.querySelector('.present-nav-container').clientHeight + (utils.isAndroid() ? 0 : 42)
    }
  }

  handleXScroll = (navIndex, rankIndex, init) => {
    const scrollEl = document.querySelector(`.rank-goods-list-${navIndex}-${rankIndex}`)
    const value = this.props.routeParams
    let tpExtra = {};
    if (value) {
      const obj = typeof value == "string" ? JSON.parse(value) : value;
      tpExtra = obj && obj.tpExtra ? obj.tpExtra : {};
    }
    tpExtra = utils.getTPExtra(tpExtra);
    const newTPExtra = utils.formatTPExtraData(
      encodeURIComponent(JSON.stringify({})),
      tpExtra
    );
    if (scrollEl) {
      const goodsVisible = []      
      const from = window.squareType == '主会场' ? 'christmas_main_square' : window.squareName
      const subs = scrollEl.querySelectorAll('.goods-item') || []
      const listener = () => {
        let { list } = this.state
        const rangeIndex = list[navIndex].curRangeIndex
        const curRange = list[navIndex].priceRanges[rangeIndex]
        const rank = curRange.rankList[rankIndex]
        for (let i = 0; i < subs.length; i++) {
          const el = subs[i];
          const item = rank.items[i]
          const visible = scrollEl && el && el.getBoundingClientRect().left > 0 && el.getBoundingClientRect().left < scrollEl.clientWidth
          if (!goodsVisible[i] && visible && item) {
            const action_time = new Date().valueOf()
            let exposure_str = `.xb.goodsDetail.${from}.gift_list..${item.goodsId}.${item.styleId}.${i}.${this.getGiftType(navIndex)}.${curRange.title}.${newTPExtra}.${rank.id}.${rank.top_name_text}.@${action_time}`
            if (exposure_str) {
              // uploadExposure({
              //   exposure_str
              // })
            }
          }
          goodsVisible[i] = visible
        }
      }
      if (init) {
        scrollEl.addEventListener('scroll', listener)
      } else {
        listener()
      }
    }
  }

  formatSaleNum = (saleNum) => {
    if (saleNum > 10000) {
      return (saleNum / 10000).toFixed(1) + 'w'
    }
    return saleNum
  }

  render() {
    const customAttributes = {
      "data-component-id": this.props["data-component-id"],
      "data-component-name": this.props["data-component-name"],
    };

    const { baseConfig } = this.props.config;
    const { list, curNavIndex, navFixed } = this.state
    return (
      <div
        className="pipeline-present"
        {...customAttributes}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        <div className="present-nav-container">
          <div 
            className={list.length === 2 ? "present-nav-list layout-2" : "present-nav-list"}
            style={{
              position: navFixed ? 'fixed' : 'relative',
              top: navFixed ? this.props.navigationBarHeight : 0,
              backgroundColor: window.backgroundColor
            }}
          >
            {
              list.map((item, index) => {
                return (
                  <div 
                    className={[curNavIndex == index ? (list.length === 2 ? `nav-item layout-2 selected` : `nav-item layout-3 selected`) : (list.length === 2 ? 'nav-item layout-2' : 'nav-item layout-3')]} key={index}
                    style={{
                      backgroundImage: curNavIndex != index ? `url(${item.unSelectedImage})` : `url(${item.selectedImage})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain"
                    }}
                    onClick={this.handleNavItemClick.bind(this, index)}
                  >
                    {/* {item.title} */}
                  </div>
                )
              })
            }
          </div>
        </div>
        <div style={{paddingTop: -10}}>
          {
            list.map((item, index) => {
              if (item.curRangeIndex == undefined) {
                item.curRangeIndex = 0
              }
              const priceRanges = item.priceRanges
              const curRange = item.priceRanges[item.curRangeIndex]
              if (!curRange) return null
              if (curRange.rankList == undefined) {
                curRange.rankList = []
              }
              if (curRange.curGroup == undefined) {
                curRange.curGroup = []
              }
              return (
                <div
                  key={index}
                  className="present-item"
                >
                  <div className="img-title" style={{background: `url(${item.titleImage}) center no-repeat`, backgroundSize: 'contain'}}></div>
                  <div className={priceRanges.length <= 1 ? "present-container no-price-range" : "present-container"} style={{backgroundColor: item.backgroundColor}}>
                    {
                      priceRanges.length > 1 && (
                        <div className="sub-nav-list">
                          {
                            priceRanges.map((rangeItem, idx) => {
                              return (
                                <div
                                  className={item.curRangeIndex == idx ? `sub-nav-item selected` : 'sub-nav-item'} key={idx}
                                  onClick={this.handlePriceRangeClick.bind(this, item, idx, index)}
                                >
                                  {rangeItem.title}
                                </div>
                              )
                            })
                          }
                        </div>
                      )
                    }
                    {curRange.curGroup.length == 0 && <div className="loading">加载中...</div>}
                    {
                      curRange.curGroup.map((rank, rankIndex) => {
                        return (
                          <div 
                            key={rankIndex} 
                            className="rank-item"
                            style={{
                              background: rank.rank_background ? `url(${rank.rank_background}) center no-repeat` : `url(${rank.bg}) center no-repeat`
                            }}
                          >
                            <div className="head-title">
                              <div className="title">{rank.top_name_text}</div>
                              <div className="sub-title">{rank.rank_subTitle || `${this.formatSaleNum(rank.sale_num)}人在逛`}</div>
                              <div className="all-nav" onClick={this.goRankPage.bind(this, rank, 1, index)}></div>
                            </div>
                            <div className={`goods-list rank-goods-list-${index}-${rankIndex}`}>
                              {
                                rank.items && rank.items.slice(0,8).map((goodsItem, goodsIndex) => {
                                  return (
                                    <div key={goodsIndex} className="goods-item" onClick={this.handleGoodsClick.bind(this, goodsItem, goodsIndex, rank, index)}>
                                      <div className="img">
                                        <LazyLoadImage
                                          width="100%"
                                          threshold={500}
                                          height="100%"
                                          src={goodsItem.pic}
                                          effect="opacity"
                                        />
                                      </div> 
                                      <div className="name">{goodsItem.goodsName}</div>
                                      <div className="bottom-cont">
                                        <div className="t1">¥</div>
                                        <div className="price">{goodsItem.price}</div>
                                        <div className="t1">起</div>
                                        {+goodsItem.officialPrice > +goodsItem.price && <div className="origin-price">¥{goodsItem.officialPrice}</div>}
                                      </div>
                                      {
                                        goodsIndex < 3 && 
                                        <div 
                                          className="top-index"
                                          style={{
                                            background: `url(${topIndexImgs[goodsIndex]}) center no-repeat`
                                          }}
                                        >
                                        </div>
                                      }
                                      {
                                        (goodsItem.discountLabel || goodsItem.tag) && 
                                        <div className="tag">{goodsItem.discountLabel || goodsItem.tag}</div>
                                      }
                                    </div>
                                  )
                                })
                              }
                              {
                                rank.items && rank.items.length > 4 &&
                                <div className={`bottom-status`}>
                                  <div className="bottom-content" onClick={this.goRankPage.bind(this, rank, 2, index)}>
                                    点击查看更多
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        )
                      })
                    }
                    {
                      curRange.rankList.length > 3 
                        && curRange.curGroup.length < curRange.rankList.length 
                          ? (
                            <div className="btn-change" onClick={this.changeRankGroup.bind(this, curRange, index)}>
                              <p>展示更多</p>
                              <img src="https://static.shihuocdn.cn/admin/files/20211216/f152ca5cbfd094e557c0b3c6cb264874.png" alt="" />
                            </div>
                          )
                          : <div className="no-more"></div>
                    }                      
                  </div>
                </div> 
              )
            })  
          }
        </div>  
      </div>
    );
  }
}

PipelineRankCollection.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineRankCollection };
export default PipelineRankCollection;



// WEBPACK FOOTER //
// ./components/pipeline-rankCollection/index.js